/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostUsersProfileInvoiceMutationRequest, PostUsersProfileInvoiceMutationResponse, PostUsersProfileInvoice400 } from "../entities/PostUsersProfileInvoice";

function getPostUsersProfileInvoiceUrl() {
  const res = { method: 'POST', url: `/users/profile/invoice` as const }  
  return res
}

/**
 * @description Генерация счета
 * @summary Генерация счета
 * {@link /users/profile/invoice}
 */
export async function postUsersProfileInvoice(data?: PostUsersProfileInvoiceMutationRequest, config: Partial<RequestConfig<PostUsersProfileInvoiceMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PostUsersProfileInvoiceMutationResponse, ResponseErrorConfig<PostUsersProfileInvoice400>, PostUsersProfileInvoiceMutationRequest>({ method : "POST", url : getPostUsersProfileInvoiceUrl().url.toString(), data : requestData, ... requestConfig })  
  return res.data
}